// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3o8LDsg5X6ZrJd {\n  background: #FAF3C0;\n  border-bottom: 1px solid #E6C60D;\n  color: #172B4D;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 22px;\n  padding: 6px;\n  position: relative;\n  text-align: center;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n._3IL-CnCT-Hn4eQ {\n  width: calc(100% - 100px);\n}\n._2ejs5eRVFoVCPD {\n  color: #5E6C84;\n}\n._3UPG0Lo-Dd_2mE {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warningBanner": "_3o8LDsg5X6ZrJd",
	"bannerMessage": "_3IL-CnCT-Hn4eQ",
	"billingLink": "_2ejs5eRVFoVCPD",
	"close": "_3UPG0Lo-Dd_2mE"
};
export default ___CSS_LOADER_EXPORT___;
